

import React, { memo, useMemo, useEffect, useState } from 'react';

import _isEmpty from 'lodash.isempty';
import _debounce from 'lodash.debounce';
import _get from 'lodash.get';

import { Image, FormModal, Text, Dropdown } from '../../../../ui-kit';
import { notify } from '../../../Notifications';

import './styles/_template-actions.scss';














const TemplateActions = (props) => {
  const {
    title,
    visible,
    onClose,
    imageUrl,
    orgName,
    getOrganisationsByName,
    action,
    templateId,
    updateTemplate,
    sourceOrganisationId
  } = props;
  const [organisations, setOrganisations] = useState([]);
  const [newOrganisation, setNewOrganisation] = useState({});

  const setOrgByNameState = async (searchTerm = '') => {
    const { data, error } = await getOrganisationsByName(searchTerm);

    if (!error) {
      setOrganisations(data.getOrganisations);
    }
  };

  const onSearchOrg = _debounce((value) => {
    setOrgByNameState(value);
  }, 300);

  useEffect(() => {
    setOrgByNameState();
  }, [getOrganisationsByName]);

  const onSave = async () => {
    if (action === 'MOVE') {
      const { error } = await updateTemplate({
        templateId,
        action: 'MOVE',
        optionalParams: {
          targetOrganisationId: newOrganisation.organisationId
        }
      });

      if (!error) {
        notify({
          title: 'Move Template',
          content: 'Template has been successfully moved to the selected workspace.',
          type: 'success'
        });
        onClose();
      }
    }

    if (action === 'CLONE') {
      const { error } = await updateTemplate({
        templateId,
        action: 'CLONE',
        optionalParams: {
          targetOrganisationId: newOrganisation.organisationId
        }
      });

      if (!error) {
        notify({
          title: 'Duplicate Template',
          content: 'Template has been successfully cloned to the selected workspace.',
          type: 'success'
        });
        onClose();
      }
    }
  };

  const onOrgSelect = ({ value: organisation }) => {
    setNewOrganisation(organisation);
  };

  const options = useMemo(() => {
    if (action === 'MOVE') {
      return organisations.map((organisation) => ({
        value: organisation,
        label: organisation.name
      })).filter((it) => sourceOrganisationId !== _get(it, 'value.organisationId'));
    }

    return organisations.map((organisation) => ({
      value: organisation,
      label: organisation.name
    }));
  }, [organisations, action]);

  return (
    <FormModal
      key="template-action-modal"
      title={title}
      visible={visible}
      onClose={onClose}
      onSave={onSave}
      saveDisabled={_isEmpty(newOrganisation)}
      stayOpenOnSave
      saveText="Save">

      <div className="template-action-modal">
        <Text heading5>Current Organisation</Text>
        <div className="template-action-modal__info">
          <Image
            width="48px"
            height="48px"
            imageUrl={imageUrl} />

          <Text>{orgName}</Text>
        </div>

        <Dropdown
          isSearchable
          placeholder="Select organisation"
          options={options}
          disabled={false}
          label="Select New Organisation"
          defaultValue={!_isEmpty(newOrganisation) ? newOrganisation.name : void 0}
          onChange={onOrgSelect}
          onInputChange={onSearchOrg} />

      </div>
    </FormModal>);

};

export default memo(TemplateActions);